import { Button, CardsProps, Header, Link, SpaceBetween, TextContent, ToggleButton } from "@amzn/awsui-components-react-v3";
import { NavigableApplicationsObject } from "./types";
import React from "react";

export interface CardDefinitionProps {
  onTogglePinApp?: (app: NavigableApplicationsObject) => void;
}

export const createCardDefinition = ({ onTogglePinApp }: CardDefinitionProps = {}): CardsProps.CardDefinition<NavigableApplicationsObject> => ({
    header: item => (
        <Header
        actions = {
            <SpaceBetween size="s" direction="horizontal">
                <ToggleButton
                pressed={!!item.isPinned}
                ariaLabel={item.isPinned ? "Unpin" : "Pin"}
                iconName="star"
                pressedIconName="star-filled"
                onChange={() => onTogglePinApp && onTogglePinApp(item)}
                // @ts-ignore
                variant="link"
                >
                    {item.isPinned && "Pinned"}
                </ToggleButton>
                <Button href={item.navLink}>
                    Go to Application
                </Button>
            </SpaceBetween>
        }>
            {item.navTitle}
        </Header>
    )
});
